import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { UntypedFormGroup, UntypedFormControl, UntypedFormBuilder,Validators } from "@angular/forms";
import { activityInput } from "../models";
@Component({
  selector: "calculator-checkbox",
  templateUrl: "./checkbox-component.html",
  styleUrls: ["./checkbox-component.css"],
})
export class CheckboxComponent implements OnInit {
  @Input() activity: activityInput;
  @Input() activityControl: UntypedFormControl;
  @Input() questionForm: UntypedFormGroup;
  @Output() change = new EventEmitter<boolean>();

  public inputCtl: UntypedFormControl;

  constructor(
    private readonly fb: UntypedFormBuilder,
  ) { }

  ngOnInit() {
    this.activityControl.setValue(this.activity.ans === 'Y' ? true : false);
    if (this.activity.ans === "Y") {
      this.change.emit(true);
    }
    if (this.activity.isRequired) {
      this.activityControl.setValidators(Validators.requiredTrue);
    }
  }

  onChange(event) {
    if (this.activity) {
      this.activity["ans"] = event.checked && event.checked === true ? "Y" : "N";
    }
    this.change.emit(event.checked);
  }
}
